import Ingredient from 'records/Ingredient';
import Base from 'records/Base';

import {
  INGREDIENT_ASYNC_ACTION_START,
  INGREDIENT_ASYNC_ACTION_ERROR,
  INGREDIENT_ASYNC_UPDATE_ACTION_SUCCESS,
  INGREDIENT_ASYNC_ARCHIVE_ACTION_SUCCESS,
  INGREDIENT_UPDATE_ACTION_SUCCESS,
  INGREDIENT_RESET_STATE,
  PRODUCT_CARD_ASYNC_UPDATE_ACTION_SUCCESS,
} from 'actions/ingredient';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Ingredient(),
});

const actionsMap = {
  [INGREDIENT_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [INGREDIENT_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [INGREDIENT_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Ingredient(action.data),
    });
  },
  [INGREDIENT_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [INGREDIENT_ASYNC_ARCHIVE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [INGREDIENT_RESET_STATE]: () => {
    return initialState;
  },
  [PRODUCT_CARD_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
};

export default function ingredient(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
